var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout"},[_c('el-header',{staticClass:"layout-header",attrs:{"height":"64px"}},[_c('AppTitle'),_c('User')],1),_c('el-main',{staticClass:"layout-main"},[_c('transition',{attrs:{"name":"router-fade","mode":"out-in"}},[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }